import React, { useState } from 'react'
import { withTheme } from 'react-jss'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'



import { Button, Title, Description } from '@portal/kit/pkg/components'
import { formatCustomCurrency, currencySign } from '@portal/kit/pkg/helpers'

import listStyle from './catalog-style'

const CatalogView = ({ catalog, theme, className, defaultOpened, disabledMessage }) => {
  const { i18n } = useTranslation()
  const [opened, setOpened] = useState(defaultOpened)
  const classes = listStyle(theme)
  const disabled = disabledMessage !== null

  let icon
  switch (catalog.internal_name) {
    case 'ran':
      icon = 'fa-house-signal'
      break;
    case 'voip_credit':
      icon = 'fa-phone'
      break;
    default:
      icon = 'fa-wifi'
      break;
  }

  return (
    <div className={classNames(classes.catalog, className)}>
      <div className={classNames(classes.catalogTitle, { [classes.disabled]: disabled })} onClick={!disabled ? () => setOpened(prev => !prev) : null}>
        <span className={classNames('fal', icon, classes.catalogIcon, { [classes.disabled]: disabled, [classes.catalogIconActive]: !disabled })} />
        <div className={classes.catalogText}>
          <Title classType='standalone'>{catalog.locales[i18n.language].name}</Title>
          <Description>{disabledMessage ? disabledMessage : catalog.locales[i18n.language].description}</Description>
        </div>
        <span className={classNames('fal', 'fa-chevron-down', classes.devicesButtonArrow, { [classes.devicesButtonArrowUp]: opened })} />
      </div>
      <div className={classNames(classes.offersList, { [classes.offersListHidden]: !opened })}>
        {catalog.offers.map(offer =>
          <div key={offer.id} className={classes.offerWrap}>
            <div className={classes.offer}>
              <p className={classes.offerName}>{offer.locales[i18n.language].name}</p>
              <div className={classes.offerBuy}>
                <p className={classes.offerPrice}>
                  {formatCustomCurrency(
                    offer.currency,
                    Math.floor(offer.price),
                    offer.price - Math.floor(offer.price) > 0
                      ? Math.round((offer.price - Math.floor(offer.price)) * 100)
                      : null,
                    currencySign(offer.currency),
                    i18n.language
                  )}
                </p>
                <Button classType="buttonSmall"  className={classes.offerButton} to={`/offers/${offer.id}`}>{i18n.t('portal.offers.buy')}</Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default withTheme(CatalogView)
